import * as immu from 'object-path-immutable'
import { reset } from './reset'

// ------------------------------------
// Persisting xeon object to elastic
// ------------------------------------
export function read( id ) {

  // Load previous object from id only on start and
  // if id has been provided in url
  return async ( dispatch, getState, api ) => {

    // Call api
    const { meta, data } = await api.simple.read( { index: "xeon", id } )

    // Parse result
    if ( meta.code == 200 && data ) {
      const { id, drugs = [], faqes = [] } = data
      // Be sure
      if ( !Array.isArray( drugs ) || !Array.isArray( faqes ) ) {
        return dispatch( reset() )
      }
      // console.log( data )
      dispatch( {
        type: `xeon`,
        data: {
          id: id,
          drugs: drugs.reduce( ( acc, cur ) => immu.set( acc, cur.id, cur ), {} ),
          faqs: faqes.reduce( ( acc, cur ) => {
            const keys = cur.keys.reduce( ( a, c ) => {
              return immu.set( a, c.key, c.val )
            }, {} )
            return immu.set( acc, cur.id, keys )
          }, {} )
        }
      } )
    } else {
      console.log( "Could not read xeon with", id )
      return dispatch( reset() )
    }

    return Promise.resolve()
  }
}

export function save() {

  return async ( dispatch, getState, api ) => {

    // Only if live connection
    if ( location.pathname.includes( "error" ) ) {
      return false
    }

    // Other keys will be reloaded anyhow
    var { id, drugs, faqs } = getState().xeon

    // Call api and prevent to many keys by using arrays
    drugs = Object.values( drugs )
    // Make reconstructable array
    const faqes = Object.keys( faqs ).map( id => {
      // Transform from
      // from: faqs[ id ] { liver:null, kalium: "no" }
      // into: { id, keys: [ { key:kalium, val: "no" } ] }
      const keys = Object.keys( faqs[ id ] ).map( key => {
        return { key: key, val: faqs[ id ][ key ] }
      } )
      return { id, keys: keys.filter( item => !!item.val ) }
    } ).filter( item => item.keys.length )

    const payload = { index: "xeon", id, body: { id } }
    // Only if necessary
    if ( drugs.length ) {
      payload[ "body" ][ "drugs" ] = drugs.slice( 0 )
    }
    if ( faqes.length ) {
      payload[ "body" ][ "faqes" ] = faqes.slice( 0 )
    }

    const { meta, data } = await api.simple.save( payload )

    if ( meta.code != 200 ) {
      console.log( "Could not save xeon object" )
      if ( process.env.NODE_ENV == "develop" ) {
        console.log( meta )
        console.log( data )
      }
    }

    return true
  }

}

// --------------------------------------------------------------------
// Ensure id
// --------------------------------------------------------------------
export function setId( id ) {
  return async ( dispatch, getState, api ) => {

    const { xeon } = getState()

    // Create new one if nothing to be loaded and there is no id
    if ( !id && !xeon.id ) {
      dispatch( { type: `xeon.id`, data: createId() } )
    }

    return Promise.resolve()
  }
}

// --------------------------------------------------------------------
// Create id for xeon object
// e.g. https://epha.health/clinic/advice/de/xid=1234-1234-1234-1234/
// --------------------------------------------------------------------
export function createId() {

  function s4() {
    return Math.floor( ( 1 + Math.random() ) * 0x10000 )
      .toString( 16 )
      .substring( 1 );
  }

  return `${s4()}-${s4()}-${s4()}-${s4()}-${s4()}`

}
